import Config from '@/config'

const { name, description } = Config.project

export default {
    general: {
        title: 'Bienvenido',
        titleTemplate: `%s | ${name}`,
        description,
    },
    home: {
        title: 'Inicio',
    },
}
